import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "",
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

export async function submitLead(data) {
  const response = await api.post("/api/leads", data);
  return response.data;
}

export default api;
